import { assignments, mapOnexGroup } from '@otto-ec/global-resources/onex'
import { OnexAssignmentsPort } from '../../../ports'
import { ActiveOnexConfig, OnexConfig, OnexId } from '@onex/model'

export const onexAssignmentsAdapter: OnexAssignmentsPort = async (
  onexId: OnexId,
  config: ActiveOnexConfig,
  defaultConfig: OnexConfig
) => {
  await new Promise((resolve) => {
    assignments.subscribe((onexData) => {
      if (onexData) {
        return resolve(undefined)
      }
    })
  })
  return mapOnexGroup(onexId, config, defaultConfig) as OnexConfig
}
